import { v4 as uuidv4 } from "uuid";

export const validateAndRepairLayout = (layout) => {
    // Define default layout
    const defaultLayout = { w: 4, h: 4, x: 0, y: 0, i: uuidv4() };

    // Check each property
    const isValidNumber = (val) => typeof val === "number" && !isNaN(val);
    let isRepaired = false;
    if (!layout) {
        isRepaired = false;
    }
    if (!isValidNumber(layout.w)) {
        layout.w = defaultLayout.w;
        isRepaired = true;
    }
    if (!isValidNumber(layout.h)) {
        layout.h = defaultLayout.h;
        isRepaired = true;
    }
    if (!isValidNumber(layout.x)) {
        layout.x = defaultLayout.x;
        isRepaired = true;
    }
    if (!isValidNumber(layout.y)) {
        layout.y = defaultLayout.y;
        isRepaired = true;
    }
    if (typeof layout.i !== "string" || layout.i.trim() === "") {
        layout.i = defaultLayout.i;
        isRepaired = true;
    }

    return isRepaired; // Return true if any repairs were made
};
